export default __webpack_public_path__ + "static/media/recycleRed.47d3a933.svg";